import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Base64 from 'base-64';
import moment from 'moment';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as homologationSemiTrailerActions from '../../actions/homologation_semi_trailer/index';
import * as accountSemiTrailerActions from '../../actions/account_semi_trailer/index';
import * as datasourceActions from '../../actions/datasource/index';
import * as tagsActions from '../../actions/common/tags/index';
import * as dynamicListActions from '../../actions/dynamic_list';

/*Style*/
import '../../../../public/style/dashboard.scss';

/* Component */
import Header from '../../components/account_semi_trailer/header';
import Title from '../../components/homologation_semi_trailer/title';
import Table from '../../components/homologation_semi_trailer/table';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Buttons from '../../components/homologation_semi_trailer/buttons';
import ModalInfo from '../../components/homologation_semi_trailer/modalInfo';
import ModalCreate from '../../components/homologation_semi_trailer/modalCreate';
import ModalDownload from '../../components/homologation_semi_trailer/modalDownload';
import ModalUpdate from '../../components/homologation_semi_trailer/modalUpdate';

import Expired from '../expired/index';

class HomologationSemiTrailer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      modalCreate: false,
      modalDownload: false,
      modalUpdate: false,
      config: {
        name: '',
        code: '',
        tags: [],
        hom: []
      },
      listsByName: {}
    };
  }

  componentWillUnmount() {
    this.props.actionsAccount.resetAccountSemiTrailer();
    this.props.actions.resetHomologationSemiTrailer();
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('vehicles');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')) {
          await this.props.dynamicListActions.getAllListWithItems({});
          await this.props.actionsAccount.fetchAccountSemiTrailerExtendedPropertiesApi({});
          await this.props.datasourceActions.fetchDatasourceApi({});
          await this.props.actionsAccount.fetchAccountSemiTrailerApi({ pag: 1, see: true });
          await this.props.actions.fetchHomologationSemiTrailerApi({});
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

    //Manage redux state changes
  async componentDidUpdate(prevProps) {
    //map lists by name
    if (prevProps.lists.loading == true 
      && this.props.lists.loading == false
      && this.props.lists.status === 200) {      
      this.props.lists.datos.map((item) => {
        this.state.listsByName[item.name.toUpperCase()] = item;
      });
    }
  }

  handleSubmit = async obj => {
    let id = document.getElementById(`homologation-id-${obj.num}`);
    let check = document.getElementById(`check-${obj.num}`);
    let row = document.getElementById(`row-${obj.num}`);
    let au = document.getElementById(`au-${obj.num}`);
    if (obj.value) {
      id.value = obj.value.id;
      check.checked = true;
      row.classList.add('active');
      au.classList.add('active-au');
    } else {
      id.value = '';
      check.checked = false;
      row.classList.remove('active');
      au.classList.remove('active-au');
    }

    const count = document.querySelectorAll('input[type="checkbox"]:checked').length;
    const countInput = document.querySelectorAll('.active .active-au').length;
    const button = document.getElementById(`button-associate`);
    const buttonCreate = document.getElementById(`button-create`);

    if (count > 0) {
      if (countInput >= count) {
        button.classList.remove('desactive');
        buttonCreate.classList.add('desactive');
      } else if (countInput > 0) {
        button.classList.add('desactive');
        buttonCreate.classList.add('desactive');
      } else {
        button.classList.add('desactive');
        buttonCreate.classList.remove('desactive');
      }
    } else {
      button.classList.add('desactive');
      buttonCreate.classList.add('desactive');
    }
  };

  handleSearch = async event => {
    if (!this.props.loading) {
      const value = event.target.value;
      await this.props.actions.fetchHomologationSemiTrailerApiNoLoadingApi({ filter: value });
    }
  };

  handleHomologation = async event => {
    if (!event.target.classList.contains('ok') && !event.target.classList.contains('desactive')) {
      const count = document.querySelectorAll('[data-homologation]').length;
      const homologations = [];
      let i;
      let homologation, source, row, externalid, check;
      for (i = 0; i <= count - 1; i++) {
        if (document.getElementById(`homologation-id-${i}`)) {
          homologation = document.getElementById(`homologation-id-${i}`).value;
          externalid = document.getElementById(`homologation-externalid-${i}`).value;
          source = document.getElementById(`homologation-datasource-${i}`).value;
          row = document.getElementById(`homologation-id-row-${i}`).value;
          check = document.getElementById(`check-${i}`).checked;
          if (homologation != '' && check) {
            homologations.push({
              entityId: parseInt(homologation, 10),
              externalEntityId: externalid,
              dataSource: source,
              unknowEntityId: parseInt(row, 10)
            });
          }
        }
      }
      event.target.classList.add('ok');
      await this.props.actions.handleHomologationSemiTrailer({ homologations: homologations });
      this.setState({ modal: true });
    }
  };

  handleCheck = async event => {
    const num = event.target.dataset.num;
    let row = document.getElementById(`row-${num}`);
    if (row.classList.contains('active')) {
      row.classList.remove('active');
    } else {
      row.classList.add('active');
    }
    const count = document.querySelectorAll('input[type="checkbox"]:checked').length;
    const button = document.getElementById(`button-associate`);
    const buttonCreate = document.getElementById(`button-create`);
    const countInput = document.querySelectorAll('.active .active-au').length;

    if (count > 0) {
      if (countInput >= count) {
        button.classList.remove('desactive');
        buttonCreate.classList.add('desactive');
      } else if (countInput > 0) {
        button.classList.add('desactive');
        buttonCreate.classList.add('desactive');
      } else {
        button.classList.add('desactive');
        buttonCreate.classList.remove('desactive');
      }
    } else {
      button.classList.add('desactive');
      buttonCreate.classList.add('desactive');
    }
  };

  handleModal = async e => {
    e.stopPropagation();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modal ? false : true;
      this.setState({ modal: reset });
      if (!reset) {
        const button = document.getElementById(`button-associate`);
        button.classList.remove('ok');
        if (this.props.statusSave == 200) {
          document.getElementById('search').value = '';
          await this.props.actions.fetchHomologationSemiTrailerApi({});
        }
      }
    }
  };

  handleChange = e => {
    let config = { ...this.state.config };
    config[e.target.dataset.update] = e.target.value;
    this.setState({
      config
    });
  };

  handleSelect = async event => {
    const element = event.target;
    element.classList.toggle('select');
  };

  handleModalCreate = async e => {
    const buttonCreate = document.getElementById(`button-create`);
    if (!buttonCreate.classList.contains('desactive')) {
      if (e.target.dataset.close == 'ok') {
        const reset = this.state.modalCreate ? false : true;
        this.setState({ modalCreate: reset });
        if (!reset) {
          this.props.actionsAccount.resetModalSemiTrailer();
          if (this.props.statusSaveAccount == 200) {
            document.getElementById('search').value = '';
            await this.props.actions.fetchHomologationSemiTrailerApi({});
            await this.props.actionsAccount.fetchAccountSemiTrailerApi({ pag: 1, see: true });
          }
        } else {
          const count = document.querySelectorAll('[data-homologation]').length;
          const homologations = [];
          let i;
          let homologation, source, row, externalid, check;
          for (i = 0; i <= count - 1; i++) {
            if (document.getElementById(`homologation-id-${i}`)) {
              homologation = document.getElementById(`homologation-id-${i}`).value;
              externalid = document.getElementById(`homologation-externalid-${i}`).value;
              source = document.getElementById(`homologation-datasource-${i}`).value;
              row = document.getElementById(`homologation-id-row-${i}`).value;
              check = document.getElementById(`check-${i}`).checked;
              if (check) {
                homologations.push(this.props.datos[i]);
              }
            }
          }
          const obj = { arr: [], arrSecond: [] };
          homologations.forEach((item, i) => {
            if (i == 0) {
              obj.name = item.entityAlias;
              obj.code = item.externalEntityId;
            }

            if (!obj.arrSecond.includes(item.dataSource)) {
              obj.arrSecond.push(item.dataSource);
              obj.arr.push({
                id: item.id,
                dataSourceId: item.id,
                dataSource: item.dataSource,
                externalEntityId: item.externalEntityId
              });
            }
          });
          this.setState({
            config: {
              name: obj.name,
              code: obj.code,
              tags: [],
              hom: obj.arr
            }
          });
        }
      }
    }
  };

  handleUpdate = async event => {
    const objSett = JSON.parse(this.props.setting.value);
    const countList = document.querySelectorAll('[data-listup]').length;
    const countHom = document.querySelectorAll('[data-homup]').length;
    const code = document.getElementById('codeup').value;
    const name = document.getElementById('nameup').value;
    var extendedProps = [];

    if (this.props.extendedProperties) {
      this.props.extendedProperties.map((item, i) => {
        var property = document.getElementById('create-extended-property-' + item.id);
        if (property && property.value) {
          var formatValue = property.value;
          if (item.dataType == 'DATE') {
            formatValue = moment(formatValue, this.props.language.account.date.format).format('YYYY-MM-DD');
          }
          extendedProps.push({
            id: item.id,
            value: formatValue
          });
        }
      });
    }

    let i, e;
    let countParents;
    let tags = [];
    let objTags;
    for (i = 0; i <= countList - 1; i++) {
      countParents = document.querySelectorAll(`[data-parentup="list-${i}"]`).length;
      for (e = 0; e <= countParents - 1; e++) {
        if (document.getElementById(`listup-${i}-${e}`).classList.contains('select')) {
          objTags = {};
          objTags.tag = document.getElementById(`listup-${i}-${e}`).innerHTML;
          tags.push(objTags);
        }
      }
    }
    let input;
    let hom = [];
    let objHom;
    for (i = 0; i <= countHom - 1; i++) {
      input = document.getElementById(`homup-${i}`);
      if (input.value != '') {
        objHom = {};
        objHom.externalEntityId = input.value;
        objHom.dataSource = input.dataset.type;
        objHom.unknowEntityId = parseInt(input.dataset.id, 10);
        hom.push(objHom);
      }
    }

    const obj = {
      alias: name,
      code: code,
      extendedProperties: extendedProps,
      tags: tags,
      homologations: hom
    };
    const arr = [obj];
    await this.props.actionsAccount.handleSemiTrailer({ semiTrailer: arr });
  };

  handleModalDownload = async e => {
    e.preventDefault();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDownload ? false : true;
      this.setState({ modalDownload: reset });
    }
  };

  handleDownload = async e => {
    await this.props.actions.fetchHomologationSemiTrailerDownloadApi();
    this.props.actions.resetModalFileSemiTrailer();
    this.setState({ modalDownload: false });
  };

  handleModalUpdate = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalUpdate ? false : true;
      this.setState({ modalUpdate: reset });
      if (!reset) {
        if (this.props.statusFile == 200) {
          document.getElementById('search').value = '';
          await this.props.actions.fetchHomologationSemiTrailerApi({});
        }
        this.props.actions.resetModalFileSemiTrailer();
        if (this.props.statusFile == null) {
          document.getElementById('file-error').classList.add('none');
          document.getElementById('file').value = '';
          document.getElementById('file-1').innerHTML = '';
          document.getElementById('btn-upload').classList.remove('active');
        }
      }
    }
  };

  handleUploadValue = async e => {
    const fullPath = document.getElementById('file').value;
    const btnUpload = document.getElementById('btn-upload');

    let extensionArr = fullPath.split('.');
    extensionArr = extensionArr[extensionArr.length - 1];
    if (
      (fullPath !== '' && extensionArr.toLowerCase() === 'xlsx') ||
      extensionArr.toLowerCase() === 'xls'
    ) {
      btnUpload.classList.add('active');
      document.getElementById('file-error').classList.add('none');
    } else {
      btnUpload.classList.remove('active');
      if (fullPath !== '') {
        document.getElementById('file-error').classList.remove('none');
      } else {
        document.getElementById('file-error').classList.add('none');
      }
    }
    document.getElementById('file-1').innerHTML = fullPath;
  };

  handleUpload = async e => {
    const btnUpload = document.getElementById('btn-upload');
    if (btnUpload.classList.contains('active')) {
      const fullPath = document.getElementById('file').files;
      const file = Base64.encode(fullPath[0]);
      await this.props.actions.fetchHomologationSemiTrailerUploadApi({ file: file });
    }
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main">
          <Header handleSearch={this.handleSearch} language={language} />
          {this.props.loading || this.props.loadingAccount ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 ||
            this.props.statusAccount === 401 ||
            this.props.statusDatasource === 401 ||
            this.props.statusSave === 401 ||
            this.props.statusSaveAccount === 401 ||
            this.props.statusFile === 401 ||
            this.props.statusTags === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 &&
            this.props.statusAccount === 200 &&
            this.props.statusDatasource === 200 &&
            this.props.statusTags === 200 ? (
            <div className="main-container">
              <Title language={this.props.language} />
              <Buttons
                handleHomologation={this.handleHomologation}
                handleModalCreate={this.handleModalCreate}
                handleModalDownload={this.handleModalDownload}
                handleModalUpdate={this.handleModalUpdate}
                language={this.props.language ? this.props.language : ''}
              />
              <Table
                datos={this.props.datos}
                datosAccount={this.props.datosAccount}
                handleSubmit={this.handleSubmit}
                handleCheck={this.handleCheck}
                language={this.props.language ? this.props.language : ''}
              />
              <ModalInfo
                handleModal={this.handleModal}
                modal={this.state.modal}
                dataSave={this.props.dataSave}
                datos={this.props.datos}
                statusSave={this.props.statusSave}
                loadingSave={this.props.loadingSave}
                language={this.props.language ? this.props.language : ''}
              />
              <ModalDownload
                handleModal={this.handleModalDownload}
                modal={this.state.modalDownload}
                handleDownload={this.handleDownload}
                language={this.props.language ? this.props.language : ''}
              />
              <ModalCreate
                handleChange={this.handleChange}
                filter={this.props.filter}
                handleSelect={this.handleSelect}
                handleSubmit={this.handleUpdate}
                handleModal={this.handleModalCreate}
                modal={this.state.modalCreate}
                datosDatasource={this.props.datosDatasource}
                statusSave={this.props.statusSaveAccount}
                loadingSave={this.props.loadingSaveAccount}
                dataSave={this.props.dataSaveAccount}
                config={this.state.config}
                language={this.props.language ? this.props.language : ''}
                extendedProperties={this.props.extendedProperties}
                  lists={this.state.listsByName}
              />
              <ModalUpdate
                handleDownload={this.handleDownload}
                handleUpload={this.handleUpload}
                handleUploadValue={this.handleUploadValue}
                handleModal={this.handleModalUpdate}
                modal={this.state.modalUpdate}
                datos={this.props.datosFile}
                loading={this.props.loadingFile}
                status={this.props.statusFile}
                language={this.props.language ? this.props.language : ''}
              />
            </div>
          ) : this.props.status === 500 ||
            this.props.statusAccount === 500 ||
            this.props.statusDatasource === 500 ||
            this.props.statusFile === 500 ||
            this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}

const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,

  setting: state.reducer.dashboard.setting,
  datos: state.reducer.homologationSemiTrailer.datos,
  loading: state.reducer.homologationSemiTrailer.loading,
  status: state.reducer.homologationSemiTrailer.status,
  loadingSave: state.reducer.homologationSemiTrailer.loadingSave,
  statusSave: state.reducer.homologationSemiTrailer.statusSave,
  dataSave: state.reducer.homologationSemiTrailer.dataSave,
  datosFile: state.reducer.homologationSemiTrailer.datosFile,
  loadingFile: state.reducer.homologationSemiTrailer.loadingFile,
  statusFile: state.reducer.homologationSemiTrailer.statusFile,
  language: state.reducer.dashboard.language,
  loadingAccount: state.reducer.accountSemiTrailer.loading,
  datosAccount: state.reducer.accountSemiTrailer.datos,
  extendedProperties: state.reducer.accountSemiTrailer.extendedProperties,
  statusAccount: state.reducer.accountSemiTrailer.status,
  datosAccountSemiTrailer: state.reducer.accountSemiTrailer.datos,
  loadingSaveAccount: state.reducer.accountSemiTrailer.loadingSave,
  statusSaveAccount: state.reducer.accountSemiTrailer.statusSave,
  dataSaveAccount: state.reducer.accountSemiTrailer.dataSave,

  datosDatasource: state.reducer.datasource.datos,
  loadingDatasource: state.reducer.datasource.loading,
  statusDatasource: state.reducer.datasource.status,

  lists: state.reducer.dynamicList.lists
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(homologationSemiTrailerActions, dispatch),
  actionsAccount: bindActionCreators(accountSemiTrailerActions, dispatch),
  datasourceActions: bindActionCreators(datasourceActions, dispatch),
  tagsActions: bindActionCreators(tagsActions, dispatch),  
  dynamicListActions: bindActionCreators(dynamicListActions, dispatch)
});

HomologationSemiTrailer.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomologationSemiTrailer);



// WEBPACK FOOTER //
// ./source/client/containers/homologation_semi_trailer/index.jsx